import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { CheckDuplicatePenPipeSize, PenPipeSizeDto } from 'models/pen/PenPipeSize';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class PenPipeSizeService extends BaseApiService<PenPipeSizeDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenPipeSizeDto);
  }

  async getPenPipeSizes(filters: QueryFilter) {
    return await this.httpClient.execWithResponseMeta<PenPipeSizeDto[]>(`api/pen-pipe-size/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }

  async checkDuplicate(data: CheckDuplicatePenPipeSize) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`api/pen-pipe-size/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
